import { managerFormService } from '@/api/services/manager-form.service';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { generateUniqueBlockName } from '@/utils/format';
export const state = () => ({
    buttonEvent: {
        eventEditPage: false,
        eventEditBlock: false,
        eventEditBlockStep2: false,
        visibilitySaveSettingPage: false,
        eventEditButton: false,
        eventEditPrizeSerialCode: false,
        eventSettingBlockLotterySerial: false,
        eventSettingBlockRejectionSerial: false
    },
    listDataManagerForm: [],
    listBlockCreated: [],
    nextId: 1,
    listMessageBlocks: [
        {
            label: '必須未選択エラー',
            messages: '必ず選択してください。',
            msg_default: '必ず選択してください。',
            action: [
                ALL_BLOCK_TYPE.BLOCK_RADIO,
                ALL_BLOCK_TYPE.BLOCK_SELECT,
                ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY,
                ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
            ],
            type_msg: 'required',
            label_id: 1
        },
        {
            label: '必須未チェックエラー',
            messages: '必ずチェックしてください。 ',
            msg_default: '必ずチェックしてください。',
            action: [ALL_BLOCK_TYPE.BLOCK_CHECKBOX],
            type_msg: 'required',
            required_checkbox: true,
            label_id: 17
        },
        {
            label: '必須未入力エラー(その他)',
            messages: '必ず入力してください。 ',
            msg_default: '必ず入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_RADIO, ALL_BLOCK_TYPE.BLOCK_CHECKBOX],
            type_msg: 'required_other',
            label_id: 2,
            required_value_other: true
        },
        {
            label: 'チェック個数エラー(相違)',
            messages: '{0}個チェックしてください。 ',
            msg_default: '{0}個チェックしてください。',
            action: [ALL_BLOCK_TYPE.BLOCK_CHECKBOX],
            type_msg: 'checked_quantity_error',
            label_id: 18
        },
        {
            label: '排他チェックエラー',
            messages: '複数選択できない項目が選択されています。',
            msg_default: '複数選択できない項目が選択されています。',
            action: [ALL_BLOCK_TYPE.BLOCK_CHECKBOX],
            type_msg: 'exclusive_check_error',
            label_id: 19
        },
        {
            label: '禁止文字入力エラー(機種依存文字、絵文字等)',
            messages: '機種依存文字、絵文字などが含まれています。[{0}]',
            msg_default: '機種依存文字、絵文字などが含まれています。[{0}]',
            action: [
                ALL_BLOCK_TYPE.BLOCK_INPUT,
                ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                ALL_BLOCK_TYPE.BLOCK_DATE,
                ALL_BLOCK_TYPE.BLOCK_FULL_NAME
            ],
            type_msg: 'character_input',
            label_id: 3
        },
        {
            label: '必須未入力エラー',
            messages: '必ず入力してください。',
            msg_default: '必ず入力してください。',
            action: [
                ALL_BLOCK_TYPE.BLOCK_INPUT,
                ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                ALL_BLOCK_TYPE.BLOCK_DATE,
                ALL_BLOCK_TYPE.BLOCK_FULL_NAME
            ],
            type_msg: 'required',
            label_id: 4,
            required_input: true
        },
        {
            label: '重複エラー',
            messages: 'すでに登録されています。',
            msg_default: 'すでに登録されています。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX],
            type_msg: 'duplicate',
            label_id: 5
        },
        {
            label: '入力形式エラー(半角英数字)',
            messages: '半角英数字で入力してください。',
            msg_default: '半角英数字で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'half-width_alphanumeric_characters',
            label_id: 6
        },
        {
            label: '入力形式エラー(全角文字)',
            messages: '全角文字で入力してください。',
            msg_default: '全角文字で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'full-width_characters',
            label_id: 7
        },
        {
            label: '入力形式エラー(ひらがな)',
            messages: 'ひらがなで入力してください。',
            msg_default: 'ひらがなで入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME],
            type_msg: 'hiragana',
            label_id: 8
        },
        {
            label: '入力形式エラー(全角カタカナ)',
            messages: '全角カタカナで入力してください。',
            msg_default: '全角カタカナで入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME],
            type_msg: 'full-width_katakana',
            label_id: 9
        },
        {
            label: '入力形式エラー(半角カタカナ)',
            messages: '半角カタカナで入力してください。',
            msg_default: '半角カタカナで入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME],
            type_msg: 'half-width_katakana',
            label_id: 10
        },
        {
            label: '入力形式エラー(数値)',
            messages: '数値を半角で入力してください。',
            msg_default: '数値を半角で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'format_numerical_value',
            label_id: 11
        },
        {
            label: '回答有効値の範囲外／桁数超過エラー',
            messages: '{0}から{1}の範囲で数値を入力してください。',
            msg_default: '{0}から{1}の範囲で数値を入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'numerical_value',
            label_id: 12
        },
        {
            label: '回答有効値の範囲外／桁数超過エラー',
            messages: '整数部{0}桁、小数部{1}桁までの数値を{2}から{3}の範囲で入力してください。',
            msg_default: '整数部{0}桁、小数部{1}桁までの数値を{2}から{3}の範囲で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'numeric_value_including_decimal_point',
            label_id: 13
        },
        {
            label: '文字数範囲エラー',
            messages: '{0}文字から{1}文字で入力してください。',
            msg_default: '{0}文字から{1}文字で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'character_range',
            label_id: 14
        },
        {
            label: '入力形式エラー(メールアドレス)',
            messages: 'メールアドレスを正しい形式で入力してください。',
            msg_default: 'メールアドレスを正しい形式で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'email',
            label_id: 15
        },
        {
            label: '入力形式エラー(数字(0-9))',
            messages: '数字で半角で入力してください。',
            msg_default: '数字で半角で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'number',
            label_id: 16
        },
        {
            label: '文字数超過エラー',
            messages: '{0}文字以内で入力してください。',
            msg_default: '{0}文字以内で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_TEXTAREA, ALL_BLOCK_TYPE.BLOCK_INPUT, ALL_BLOCK_TYPE.BLOCK_FULL_NAME],
            type_msg: 'maxlength_textarea',
            label_id: 20
        },
        {
            label: '入力形式エラー(電話番号)',
            messages: '正しい形式で入力されていません。',
            msg_default: '正しい形式で入力されていません。',
            action: [ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER],
            type_msg: 'number',
            label_id: 21
        },
        {
            label: '入力形式エラー(郵便番号)',
            messages: '正しい形式で入力されていません。',
            msg_default: '正しい形式で入力されていません。',
            action: [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE],
            type_msg: 'number',
            label_id: 22
        },
        {
            label: 'キーワード相違エラー',
            messages: '入力内容が誤っています。',
            msg_default: '入力内容が誤っています。',
            action: [ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX],
            type_msg: 'keyword_pattern',
            label_id: 23
        },
        {
            label: '入力形式エラー(年月日)',
            messages: '日付として正しく入力されていません。',
            msg_default: '日付として正しく入力されていません。',
            action: [ALL_BLOCK_TYPE.BLOCK_DATE],
            type_msg: 'date',
            label_id: 24
        },
        {
            label: '入力年月日範囲外エラー',
            messages: '{0}/1/1から{1}/12/31の範囲で入力してください。',
            msg_default: '{0}/1/1から{1}/12/31の範囲で入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_DATE],
            type_msg: 'date_year_range',
            label_id: 25
        },
        {
            label: '確認入力エラー',
            messages: '入力した内容が一致しません。',
            msg_default: '入力した内容が一致しません。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'keyword_pattern',
            label_id: 26
        },
        {
            label: '入力形式エラー(カタカナ)',
            messages: 'カタカナで入力してください。',
            msg_default: 'カタカナで入力してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_FULL_NAME],
            type_msg: 'katakana',
            label_id: 27
        },
        {
            label: '空ファイルエラー',
            messages: '選択されたファイルは0バイトです。',
            msg_default: '選択されたファイルは0バイトです。',
            action: [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE],
            type_msg: 'empty_file',
            label_id: 28
        },
        {
            label: 'サイズ超過エラー',
            messages: 'ファイルサイズは{0}キロバイト以内にしてください。',
            msg_default: 'ファイルサイズは{0}キロバイト以内にしてください。',
            action: [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE],
            type_msg: 'file_size_exceeded',
            label_id: 29
        },
        {
            label: 'ファイル名文字数超過エラー',
            messages: 'ファイル名が{0}文字を超えています。',
            msg_default: 'ファイル名が{0}文字を超えています。',
            action: [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE],
            type_msg: 'file_name_length_exceeded',
            label_id: 30
        },
        {
            label: 'ファイル未指定エラー',
            messages: 'ファイルを選択してください。',
            msg_default: 'ファイルを選択してください。',
            action: [ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE],
            type_msg: 'required',
            label_id: 31
        },
        {
            label: '郵便番号必須未入力エラー',
            messages: '郵便番号検索には、上3桁の入力が必要です。',
            msg_default: '郵便番号検索には、上3桁の入力が必要です。',
            action: [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE],
            type_msg: 'zipcode_required',
            label_id: 32
        },
        {
            label: '該当住所なしエラー',
            messages: '該当する住所がありません。',
            msg_default: '該当する住所がありません。',
            action: [ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE],
            type_msg: 'address_not_found',
            label_id: 33
        },
        {
            label: '残席なしエラー',
            messages: '「{0}」の残数がありません。',
            msg_default: '「{0}」の残数がありません。',
            action: [ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY],
            type_msg: 'no_seat_available',
            label_id: 34
        },
        {
            label: '入力該当なし',
            messages: 'シリアルコードが誤っています。再度ご確認ください。',
            msg_default: 'シリアルコードが誤っています。再度ご確認ください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'no_suitable_data_to_input',
            label_id: 35
        },
        {
            label: '使用済み',
            messages: 'すでに使用済みのシリアルコードです。再度ご確認ください。',
            msg_default: 'すでに使用済みのシリアルコードです。再度ご確認ください。',
            action: [ALL_BLOCK_TYPE.BLOCK_INPUT],
            type_msg: 'used',
            label_id: 36
        }
    ]
});

export const getters = {
    dataList(state) {
        return state.dataList;
    },
    listDataManagerForm: (state) => state.listDataManagerForm,
    listBlockCreated: (state) => state.listBlockCreated,
    nextId: (state) => state.nextId,
    listMessageBlocks: (state) => state.listMessageBlocks,
    buttonEvent: (state) => state.buttonEvent
};

export const actions = {
    registerManagerForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerManagerForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    updateManagerForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateManagerForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    getListManagerForm({ dispatch, commit }, query) {
        commit('listRequest', []);
        return managerFormService.getListManagerForm(query).then(
            (data) => {
                commit('listManagerFormSuccess', data.data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    getDetailManagerForm({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getDetailManagerForm(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    getAnalytics({ dispatch, commit }, data) {
        commit('registerRequest', []);
        return managerFormService.getAnalytics(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getRegisterEmailsAnalytics({ dispatch, commit }, data) {
        commit('registerRequest', []);
        return managerFormService.getRegisterEmailsAnalytics(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListBlockOriginalOfForm({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListBlockOriginalOfForm(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListBlockOfForm({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListBlockOfForm(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListBlockOfFormSerial({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListBlockOfFormSerial(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListOptionOfBlock({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListOptionOfBlock(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateAnalytics({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateAnalytics(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteAnalytics({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteAnalytics(data).then(
            (data) => {
                commit('deleteSuccess', data.data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteManagerForm({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteManagerForm(data).then(
            (data) => {
                commit('deleteSuccess', data.data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    settingPublishTime({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.settingPublishTime(data).then(
            (data) => {
                commit('deleteSuccess', data.data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    stopPublishNow({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.stopPublishNow(data).then(
            (data) => {
                commit('deleteSuccess', data.data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    exportDataBlockForm({ dispatch, commit }, query) {
        commit('listRequest', []);
        return managerFormService.exportDataBlockForm(query).then(
            (data) => {
                commit('listManagerFormSuccess', data.data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    exportDataRegisterEmail({ dispatch, commit }, query) {
        commit('listRequest', []);
        return managerFormService.exportDataRegisterEmail(query).then(
            (data) => {
                commit('listManagerFormSuccess', data.data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    syncFormPublish({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.syncFormPublish(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    getListTemplateManagerForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.getListTemplateManagerForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerTemplateManagerForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerTemplateManagerForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getDetailTemplateManagerForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.getDetailTemplateManagerForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    formSettingEmail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.formSettingEmail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getDetailSettingEmail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.getDetailSettingEmail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    copyFormApi({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.copyFormApi(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListDomainEmail({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListDomainEmail(data).then(
            (data) => {
                commit('listSuccess', data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerDomainEmail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerDomainEmail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateDomainEmail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateDomainEmail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteDomainEmail({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteDomainEmail(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListCustomDomain({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListCustomDomain(data).then(
            (data) => {
                commit('listSuccess', data);
                return data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerCustomDomain({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerCustomDomain(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateCustomDomain({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateCustomDomain(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteCustomDomain({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteCustomDomain(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListEmailSender({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListEmailSender(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerEmailSender({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerEmailSender(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateEmailSender({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateEmailSender(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteEmailSender({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteEmailSender(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListEmailReply({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListEmailReply(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListAllEmailReply({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListAllEmailReply(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListAllEmailFrom({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListAllEmailFrom(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListAllTemplateMail({ dispatch, commit }, data) {
        commit('listRequest', []);
        return managerFormService.getListAllTemplateMail(data).then(
            (data) => {
                commit('listSuccess', data.data);
                return data.data;
            },
            (error) => {
                commit('listFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateTemplateMail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateTemplateMail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteTemplateMail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.deleteTemplateMail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerEmailReply({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerEmailReply(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateEmailReply({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateEmailReply(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteEmailReply({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteEmailReply(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteFormAndData({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteFormAndData(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    deleteAllResultAnalytics({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteAllResultAnalytics(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deletePermanentlyResultAnalytics({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deletePermanentlyResultAnalytics(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deletePermanently({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deletePermanently(data).then(
            (data) => {
                commit('deleteSuccess', data);
                return data;
            },
            (error) => {
                commit('deleteFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    sendMailTest({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.sendMailTest(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    registerTemplateMail({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.registerTemplateMail(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    importSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.importSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    downloadSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.downloadSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    importProductForPrize({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.importProductForPrize(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    downloadProductForPrize({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.downloadProductForPrize(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    autoGenSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.autoGenSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getDailyLimitsPrizeForm({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.getDailyLimitsPrizeForm(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getAnalyticsLottery({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.getAnalyticsLottery(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    downloadLotteryHistory({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.downloadLotteryHistory(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    downloadSerialCodes({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.downloadSerialCodes(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListSerialCode({ dispatch, commit }, data) {
        commit('listRequest', data);
        return managerFormService.getListSerialCode(data).then(
            (data) => {
                commit('listSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    getListSerialCodeAnalytics({ dispatch, commit }, data) {
        commit('listRequest', data);
        return managerFormService.getListSerialCodeAnalytics(data).then(
            (data) => {
                commit('listSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    createSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.createSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    updateSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.updateSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('updateFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    deleteSerialCode({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.deleteSerialCode(data).then(
            (data) => {
                commit('deleteSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    downloadListSerialCode({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.downloadListSerialCode(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    jobCheckImportSerial({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.jobCheckImportSerial(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    jobCheckAutoGenSerial({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.jobCheckAutoGenSerial(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    jobDeleteListSerial({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.jobDeleteListSerial(data).then(
            (data) => {
                commit('deleteSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    jobDeleteS3AnalyticsStatus({ dispatch, commit }, data) {
        commit('deleteRequest', data);
        return managerFormService.jobDeleteS3AnalyticsStatus(data).then(
            (data) => {
                commit('deleteSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },
    checkStatusCopySerial({ dispatch, commit }, data) {
        commit('registerRequest', data);
        return managerFormService.checkStatusCopySerial(data).then(
            (data) => {
                commit('registerSuccess', data);
                dispatch('notification/success', 'Registration successful', { root: true });
                return data;
            },
            (error) => {
                commit('registerFailure', error);
                dispatch('notification/error', error, { root: true });
            }
        );
    },

    saveStateBlockForm({ commit }, data) {
        commit('handleSaveStateBlockForm', data);
    },

    updateBlockList({ commit }, data) {
        commit('handleUpdateBlockList', data);
    },

    updateMessages({ commit }, data) {
        commit('handleUpdateMsg', data);
    },

    updateButtonEvent({ commit }, data) {
        commit('handleUpdateButtonEvent', data);
    }
};

export const mutations = {
    registerRequest(state, data) {
        state.status = false;
        state.data = data;
    },
    registerSuccess(state, data) {
        state.status = true;
        state.data = data;
    },
    registerFailure(state) {
        state.status = {};
        state.data = null;
    },
    listRequest(state, data) {
        state.status = false;
        state.dataList = data;
    },
    listSuccess(state, data) {
        state.status = true;
        state.dataList = data;
    },
    listFailure(state) {
        state.status = {};
        state.dataList = [];
    },
    deleteRequest(state, data) {
        state.status = false;
        state.data = data;
    },
    deleteSuccess(state, data) {
        state.status = true;
        state.data = data;
    },
    deleteFailure(state) {
        state.status = {};
        state.data = null;
    },

    listManagerFormSuccess(state, data) {
        state.listDataManagerForm = data;
    },

    handleSaveStateBlockForm(state, data) {
        if (!data?.id) {
            data.block_name = generateUniqueBlockName(state.listBlockCreated, data.block_name);
            state.listBlockCreated.push({ id: state.nextId, status_record_block: 'create', ...data });
            state.nextId += 1;
        } else {
            const idxUpdate = state.listBlockCreated.findIndex((stItem) => stItem.id == data.id);
            state.listBlockCreated[idxUpdate] = data;

            state.listBlockCreated.forEach((item) => {
                ['prefecture_insertion', 'city_insertion', 'town_area_name_insertion'].forEach((key) => {
                    if (item.block_post_code[key]?.id === data.id) {
                        item.block_post_code[key].block_name = data.block_name;
                    }
                });
            });
        }
    },

    handleUpdateBlockList(state, data) {
        state.listBlockCreated = data;
    },

    handleUpdateMsg(state, data) {
        if (!data || data?.length <= 0) {
            state.listMessageBlocks.forEach((stateItemMsg) => {
                stateItemMsg.messages = stateItemMsg.msg_default;
            });
            return;
        }
        data.forEach((itemData) => {
            const editMsg = state.listMessageBlocks.find((upItem) => upItem.label_id === itemData.label_id);
            if (!editMsg) return;
            editMsg.messages = itemData.messages;
        });
    },

    handleUpdateButtonEvent(state, data) {
        state.buttonEvent = {
            ...state.buttonEvent,
            ...data
        };
    }
};
